// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1koPw","scrollContainer":"styles_scrollContainer__3L9Ix","textarea":"styles_textarea__1xUwb","postfix":"styles_postfix__hbS8m"};